/* eslint-disable no-unused-vars */
import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
// creates a beautiful scrollbar
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import { Edit } from "@material-ui/icons/";
import { BookmarkBorder } from "@material-ui/icons/";
import DesktopWindows from "@material-ui/icons/DesktopWindows";
// core components
import Navbar from "components/Navbars/Navbar.js";
import Footer from "components/Footer/Footer.js";
import Sidebar from "components/Sidebar/Sidebar.js";
import styles from "assets/jss/material-dashboard-react/layouts/adminStyle.js";

import bgImage from "assets/img/sidebar-2.jpg";
import logo from "assets/img/logo1.png";

import Medical from "views/Signature/Medical2567.js";
import Administrative from "views/Signature/Administrative2567";
import Nurse from "views/Signature/Nurse2567.js";
import HealthDev from "views/Signature/HealthDev2567.js";
import KPI from "views/Signature/KPI";

let ps;

const routes = [
  {
    name: "ภาพรวมตัวชี้วัด",
    icon: BookmarkBorder,
    component: KPI,
    layout: "/signature",
    path: "/kpi"
  },
  {
    name: "รองผู้อำนวยการด้านวิชาการและการแพทย์",
    icon: Edit,
    component: Medical,
    layout: "/signature",
    path: "/medical"
  },
  {
    name: "รองผู้อำนวยการด้านอำนวยการ",
    icon: Edit,
    component: Administrative,
    layout: "/signature",
    path: "/administrative"
  },
  {
    name: "รองผู้อำนวยการด้านการพยาบาล",
    icon: Edit,
    component: Nurse,
    layout: "/signature",
    path: "/nurse"
  },
  {
    name: "รองผู้อำนวยการด้านพัฒนาระบบสุขภาพ",
    icon: Edit,
    component: HealthDev,
    layout: "/signature",
    path: "/health"
  },
  {
    name: "การลงนามคำรับรอง ฯ หัวหน้ากลุ่มงาน",
    icon: DesktopWindows,
    layout: "/subsignature",
    path: ""
  }
];

const switchRoutes = (
  <Switch>
    {routes.map((prop, key) => {
      return (
        <Route
          path={prop.layout + prop.path}
          component={prop.component}
          key={key}
        />
      );
    })}
    <Redirect from="/signature" to="/signature" />
  </Switch>
);

const useStyles = makeStyles(styles);

export default function Signature({ ...rest }) {
  // styles
  const classes = useStyles();
  // ref to help us initialize PerfectScrollbar on windows devices
  const mainPanel = React.createRef();
  // states and functions
  const [image, setImage] = React.useState(bgImage);
  const [color, setColor] = React.useState("blue");
  const [fixedClasses, setFixedClasses] = React.useState("dropdown show");
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const handleImageClick = image => {
    setImage(image);
  };
  const handleColorClick = color => {
    setColor(color);
  };
  const handleFixedClick = () => {
    if (fixedClasses === "dropdown") {
      setFixedClasses("dropdown show");
    } else {
      setFixedClasses("dropdown");
    }
  };
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  const getRoute = () => {
    return window.location.pathname !== "/admin/maps";
  };
  const resizeFunction = () => {
    if (window.innerWidth >= 960) {
      setMobileOpen(false);
    }
  };
  // initialize and destroy the PerfectScrollbar plugin
  React.useEffect(() => {
    if (navigator.platform.indexOf("Win") > -1) {
      ps = new PerfectScrollbar(mainPanel.current, {
        suppressScrollX: true,
        suppressScrollY: false
      });
      document.body.style.overflow = "hidden";
    }
    window.addEventListener("resize", resizeFunction);
    // Specify how to clean up after this effect:
    return function cleanup() {
      if (navigator.platform.indexOf("Win") > -1) {
        ps.destroy();
      }
      window.removeEventListener("resize", resizeFunction);
    };
  }, [mainPanel]);
  return (
    <div className={classes.wrapper}>
      <Sidebar
        routes={routes}
        logoText={"การลงนามคำรับรองฯ"}
        logo={logo}
        image={image}
        handleDrawerToggle={handleDrawerToggle}
        open={mobileOpen}
        color={color}
        {...rest}
      />
      <div className={classes.mainPanel} ref={mainPanel}>
        <Navbar
          routes={routes}
          handleDrawerToggle={handleDrawerToggle}
          {...rest}
        />
        {/* On the /maps route we want the map to be on full screen - this is not possible if the content and conatiner classes are present because they have some paddings which would make the map smaller */}
        {getRoute() ? (
          <div className={classes.content}>
            <div className={classes.container}>{switchRoutes}</div>
          </div>
        ) : (
          <div className={classes.map}>{switchRoutes}</div>
        )}
        {getRoute() ? <Footer /> : null}
        {/* <FixedPlugin
          handleImageClick={handleImageClick}
          handleColorClick={handleColorClick}
          bgColor={color}
          bgImage={image}
          handleFixedClick={handleFixedClick}
          fixedClasses={fixedClasses}
        /> */}
      </div>
    </div>
  );
}
